export const setPrevRoute = (route) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('prevRoute', route);
  }
};

export const getPrevRoute = () => {
  if (typeof window !== 'undefined') {
    const storedData = localStorage.getItem('prevRoute');
    return storedData;
  }
};
